/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ArchiveGoalMenuItem_goal = {
    readonly id: string;
    readonly readableId: number;
    readonly archived: boolean | null;
    readonly nextReviewAt: string;
    readonly " $refType": "ArchiveGoalMenuItem_goal";
};
export type ArchiveGoalMenuItem_goal$data = ArchiveGoalMenuItem_goal;
export type ArchiveGoalMenuItem_goal$key = {
    readonly " $data"?: ArchiveGoalMenuItem_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"ArchiveGoalMenuItem_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArchiveGoalMenuItem_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readableId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextReviewAt",
      "storageKey": null
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '8123fa780ad048a551e2775cf90bb209';
export default node;
